import React from "react"
import { Col, Container, Nav, NavDropdown, Navbar, Row } from "react-bootstrap"
import { Link } from "react-bootstrap-icons"
import { FR, GB } from "country-flag-icons/react/3x2"
import { patchUser } from "../../api/api_user"
import withHooks from "./WithHooks"
import Cookies from "universal-cookie"
import { registerLocale } from "react-datepicker"

class Navigation extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.mercureTryUrl = "/api"
    this.cookies = new Cookies()

    this.state = {
      currentUser: this.props.RightsManager.currentUser,
      mercureStateColor: "#fff",
      mercureTarget: "",
    }
    this.dMgr.debug("init_state:", this.state)

    this.changeLanguage = this.changeLanguage.bind(this)
    this.registerLanguage = this.registerLanguage.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.tryMercure = this.tryMercure.bind(this)
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
    this.registerLanguage(this.state.currentUser.preferredLanguage)
    this.props.changeLanguage(this.state.currentUser.preferredLanguage)
    this.dMgr.debug("languuage:", this.state.currentUser.preferredLanguage)

    // this.tryMercure()
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  tryMercure() {
    // let callbacks = {
    //   errorCallback: (response) => {
    //     // console.log("error mercure");
    //     this.setState({ mercureStateColor: "#f00", mercureTarget: response.target.url })
    //   },
    //   connectedCallback: (response) => {
    //     // console.log("connected mercure");
    //     closeMercure(this.mercureTryUrl)
    //     // setTimeout(() => {
    //     //   closeMercure(this.mercureTryUrl)
    //     // }, 10000)
    //     this.setState({ mercureStateColor: "#0f0", mercureTarget: "" })
    //   },
    // }
    // mercureListener(this.mercureTryUrl, callbacks)
  }

  handleScroll() {
    const isScrolled = window.scrollY > 40
    this.setState({ isScrolled })
  }

  async registerLanguage(language) {
    let locale
    switch (language) {
      default:
      case "en":
        locale = await import(`date-fns/locale/en-US`)
        break
      case "fr":
        locale = await import(`date-fns/locale/fr`)
        break
      case "de":
        locale = await import(`date-fns/locale/de`)
        break
    }
    registerLocale(language, locale.default)
  }

  async changeLanguage(language) {
    this.props.changeLanguage(language)
    this.registerLanguage(language)

    await patchUser(this.state.currentUser.id, { preferredLanguage: language })

    let currentUser = { ...this.state.currentUser }
    currentUser.preferredLanguage = language

    this.cookies.set("bg_user", currentUser)

    this.setState({ currentUser })
  }

  render() {
    this.dMgr.rendering()

    let profileTitle = this.state.currentUser.firstname
    profileTitle = <>{profileTitle}</>

    let selectedLanguage = ""
    switch (this.state.currentUser.preferredLanguage) {
      default:
      case "en":
        selectedLanguage = <GB title="English" className="lang_flag" />
        break
      case "fr":
        selectedLanguage = <FR title="Français" className="lang_flag" />
        break
    }

    let toRender = (
      <Navbar
        expand="lg"
        className={`bg-body-tertiary fixed-top ${this.state.isScrolled ? "navbar-scrolled" : ""} box-shadow-lvl2`}
        data-bs-theme="dark"
        onSelect={(eventKey) =>
          this.props.router.nav({
            url: "/" + eventKey,
          })
        }
      >
        <Container fluid>
          <Row>
            <Col md={2} className="text-center">
              <Navbar.Brand
                data-pagename="dashboard"
                onClick={() =>
                  this.props.router.nav({
                    url: "/admin/dashboard",
                  })
                }
              >
                <img src="favicon.png" className="app-logo" alt="" /> Brainy Games
              </Navbar.Brand>
            </Col>

            <Col md={10}>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto" variant="pills" style={{ width: "100%" }}>
                  <Nav.Link eventKey="" active={this.props.pageMenu === "app" ? "active" : ""}>
                    {this.props.t("nav.app")}
                  </Nav.Link>
                  {this.props.RightsManager.userHasRole("ROLE_ADMIN") && (
                    <Nav.Link eventKey="admin/dashboard" active={this.props.pageMenu === "dashboard" ? "active" : ""}>
                      {this.props.t("nav.dashboard")}
                    </Nav.Link>
                  )}
                  {this.props.RightsManager.userHasRole("ROLE_ADMIN") && (
                    <Nav.Link eventKey="admin/questions" active={this.props.pageMenu === "questions" ? "active" : ""}>
                      {this.props.t("nav.questions")}
                    </Nav.Link>
                  )}
                  {this.props.RightsManager.userHasRole("ROLE_ADMIN") && (
                    <Nav.Link eventKey="admin/question_types" active={this.props.pageMenu === "question_types" ? "active" : ""}>
                      {this.props.t("nav.questionTypes")}
                    </Nav.Link>
                  )}
                  {this.props.RightsManager.userHasRole("ROLE_ADMIN") && (
                    <Nav.Link eventKey="admin/response_choices" active={this.props.pageMenu === "response_choices" ? "active" : ""}>
                      {this.props.t("nav.responseChoices")}
                    </Nav.Link>
                  )}
                  {this.props.RightsManager.userHasRole("ROLE_ADMIN") && (
                    <Nav.Link eventKey="admin/response_types" active={this.props.pageMenu === "response_types" ? "active" : ""}>
                      {this.props.t("nav.responseTypes")}
                    </Nav.Link>
                  )}
                  {this.props.RightsManager.userHasRole("ROLE_ADMIN") && (
                    <Nav.Link eventKey="admin/statistics" active={this.props.pageMenu === "statistics" ? "active" : ""}>
                      {this.props.t("nav.statistics")}
                    </Nav.Link>
                  )}
                  {this.props.RightsManager.userHasRole("ROLE_ADMIN") && (
                    <Nav.Link eventKey="admin/users" active={this.props.pageMenu === "users" ? "active" : ""}>
                      {this.props.t("nav.users")}
                    </Nav.Link>
                  )}
                </Nav>

                <Nav variant="pills" id="language-nav">
                  <NavDropdown title={selectedLanguage} id="language-dropdown" className="min-width-55">
                    <NavDropdown.Item onClick={() => this.changeLanguage("en")}>
                      <GB title="English" className="lang_flag" />
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => this.changeLanguage("fr")}>
                      <FR title="Français" className="lang_flag" />
                    </NavDropdown.Item>
                    {/*   <NavDropdown.Item onClick={() => this.changeLanguage("dplaye")}>
                      <DE title="Deutsch" className="lang_flag" />
                    </NavDropdown.Item> */}
                  </NavDropdown>

                  <NavDropdown title={profileTitle} id="profile">
                    <NavDropdown.Item eventKey="admin/my_profile">{this.props.t("nav.myProfile")}</NavDropdown.Item>
                    {this.props.RightsManager.userHasRole("ROLE_ADMIN") && (
                      <>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="/admin/todo">TODO</NavDropdown.Item>
                      </>
                    )}
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/logout">{this.props.t("nav.logout")}</NavDropdown.Item>
                  </NavDropdown>

                  <Nav.Link href={this.state.mercureTarget} target="_blank">
                    <Link style={{ color: this.state.mercureStateColor }} />
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Col>
          </Row>
        </Container>
      </Navbar>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(Navigation)
